module.exports = __webpack_public_path__ + "static/bartek-99b85410d2273a31dbcc3129b10666ad.jpeg";